// src/config/dashboardWidgets.js
//
// Реестр виджетов дашборда аналитики. Видимость хранится в
// shop.dashboardConfig = { ключ: bool }. Нет ключа → берётся `default`.
// Добавить новый график = добавить строку сюда (+ ключ в ALLOWED_WIDGETS на бэке).
//
// Главная плашка (выручка/прибыль/средний чек) — ядро, не виджет, всегда видна.

export const WIDGETS = [
  { key: 'comparison',  labelKey: 'analytics.w.comparison',  default: true  },
  { key: 'trend',       labelKey: 'analytics.w.trend',       default: true  },
  { key: 'payments',    labelKey: 'analytics.w.payments',    default: true  },
  { key: 'topProducts', labelKey: 'analytics.w.topProducts', default: true  },
  { key: 'category',    labelKey: 'analytics.w.category',    default: false },
  { key: 'employees',   labelKey: 'analytics.w.employees',   default: false },
  { key: 'hours',       labelKey: 'analytics.w.hours',       default: false },
];

export const WIDGET_BY_KEY = WIDGETS.reduce((m, w) => (m[w.key] = w, m), {});

export function isWidgetOn(shop, key) {
  const reg = WIDGET_BY_KEY[key];
  if (!reg) return false;
  const cfg = shop && shop.dashboardConfig && typeof shop.dashboardConfig === 'object'
    ? shop.dashboardConfig : {};
  const v = cfg[key];
  return v === undefined || v === null ? (reg.default !== false) : !!v;
}
